import { toChildArray, cloneElement } from 'preact';
import { useState } from 'preact/hooks';
import Collapsed from './collapsed';
import Expanded from './expanded';
import style from './style.css';

/**
 * @function Accordion
 */
const Accordion = ({ isContextCard, children, initial, onClick }) => {
  const [open, setOpen] = useState(initial);

  const handleOpen = (id, item) => {
    id === open ? setOpen('') : setOpen(id);
    onClick && !(id === open) && onClick(item);
  };

  const childrenArray = toChildArray(children);

  return (
    <div className={style.accordion}>
      {childrenArray.map((child, index) => {
        const id = child.props.children[0].props.id;

        const collapsed = cloneElement(child.props.children[0], {
          handleOpen,
          isLast: index === childrenArray.length - 1 ? true : false,
          open,
        });

        const expanded = child.props.children[1];

        return (
          <div
            className={
              isContextCard ? style.contextAccordion : style.itemContainer
            }>
            {collapsed}
            {id === open && expanded}
          </div>
        );
      })}
    </div>
  );
};

Accordion.Collapsed = Collapsed;
Accordion.Expanded = Expanded;
Accordion.Item = ({ children }) => children;

export default Accordion;



// WEBPACK FOOTER //
// ./components/accordion/index.js